export enum DialogSize {
  small = "small",
  normal = "normal",
  large = "large",
  xlarge = "xlarge",
  xxlarge = "xxlarge",
}

export type CurrentLocationDotBG = "grey" | "success" | "yellow" | "orange";

export interface CurrentLocationDotSettings {
  seconds: number;
  color: CurrentLocationDotBG;
}

export interface GridHeaderOption {
  key: string;
  title: string;
}
